import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input} from 'reactstrap';
import apiBarcode from '../../services/api/apiBarcode';
import {pushNewItemHistory} from "../../services/api/apiItemHistory";

class ModalEditItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: {},
            isLoadingSave: false
        };
    }

    componentDidMount() {
        this._loadStateFromProps();
    }

    _loadStateFromProps = () => {
        const {item} = this.props;
        this.setState({item});
    };

    _handleChangeInput = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const name = e.target.name;
        console.log( value )
        const {item} = this.state;
        this.setState({item: {...item, [name]: value}});
    };

    _renderIconLoading = () => {
        if (this.state.isLoadingSave)
            return <i className='icon-spinner2 spinner ml-2'/>;
    };

    _handleClickSave = async () => {
        this.setState({isLoadingSave: true});

        try {
            const {item: itemOld} = this.props
            const {items: itemsOld, products: productsOld, ...listInfoOld} = itemOld
            const {item} = this.state;
            const {items: itemsNew, products: productsNew, ...listInfoNew} = item
            const diff = this._diff(listInfoOld, listInfoNew)
            let from = []
            let to = []
            diff.forEach(itemDiff => {
                from.push(`${itemDiff}: ${listInfoOld[itemDiff]}`)
                to.push(`${itemDiff}: ${listInfoNew[itemDiff]}`)
            })


            const resUpdated = await apiBarcode.updateBarcode(item._id, item);
            const {success, message} = resUpdated.data;
            if (!success) throw new Error(message);

            await this.props.reload();
            this.props.toggle();

            pushNewItemHistory(`${item.barcodeNumber}_1`, {
                event_key: 'edit_shipping_address',
                event_description: 'Edit shipping address.',
                event_meta: {
                    from: from.toString(', '),
                    to: to.toString(', ')
                }
            })
        } catch (e) {
            alert(e.message);
        }

        this.setState({isLoadingSave: false});
    }

    _diff = (oldObj, newObj) => {
        return Object.entries(newObj).map(([key, value]) => {
            if (oldObj[key] !== newObj[key]) {
                return key
            }
            return null
        }).filter(Boolean)
    }

    render() {
        const {isOpen, toggle} = this.props;
        const {isLoadingSave, item} = this.state;
        const {orderNumber, name, address1, address2, city, state, country, phone, postalCode, qship} = item;

        return (
            <div>
                <Modal isOpen={isOpen} toggle={toggle} className={this.props.className}>
                    <ModalHeader toggle={toggle}>Edit Item</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>Order Number</Label>
                            <Input name='orderNumber' value={orderNumber} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input name='name' value={name} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Address1</Label>
                            <Input name='address1' value={address1} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Address2</Label>
                            <Input name='address2' value={address2} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>City</Label>
                            <Input name='city' value={city} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>State</Label>
                            <Input name='state' value={state} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Country</Label>
                            <Input name='country' value={country} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Phone</Label>
                            <Input name='phone' value={phone} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Postal Code</Label>
                            <Input name='postalCode' value={postalCode} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label check>FastShip</Label>
                            <Input name='qship' value={qship} onChange={this._handleChangeInput}/>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>Cancel</Button>{' '}
                        <Button color="primary" onClick={this._handleClickSave} disabled={isLoadingSave}>
                            Save
                            {this._renderIconLoading()}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalEditItem;